module.exports = __webpack_public_path__ + "static/media/more-selected.4dd34d0f.svg";